import React from 'react';
import './styles.scss'

export default props => (
    <svg onClick={ () => props.setFunction() } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.41 79.83"><defs></defs><g id="Warstwa_2" data-name="Warstwa 2"><g id="kroki"><path className={"cls-1 " + ( props.active === 4 ? 'active' : '')} d="M56.41,49.36v11h-10V78.83h-12V60.37H1V47.83L34.41,1h12V50.36h7m-42.55,0H34.41V16.13h-.23Z"/></g></g></svg>
)